import {PeachyLogo} from '../../../global/assets/PeachyLogo/PeachyLogo'
import {Header} from '../Header'
import styles from './WelcomeHeader.module.css'

export function WelcomeHeader() {
    return <Header class={styles.header}>
        <PeachyLogo/>
    </Header>
}
